import { Badge, Button, Loader } from "@mantine/core";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../stores/LeadsStore";
import { IconStar, IconStarFilled } from "@tabler/icons-react";
import { useParams } from "react-router-dom";
import { getFirstPagePrm, getFirstPagePrmUser } from "../../../../api/PRMAPI";
import { transformFilterToServer, transformServerToFilter } from "../../../../functions/utilFunctions";

const LeadsQuickNewFilter = ({ apiRef, tableFilter, setTableFilter }) => {
  const { userId } = useParams();
  const leadsFilter = useLeadsStore((s) => s.filter);
  const setLeadsFilter = useLeadsStore((s) => s.setFilter);
  const newsCount = useLeadsStore((s) => s.newsCount);
  const setNewsCount = useLeadsStore((s) => s.setNewsCount);
  const reloadAll = useLeadsContainerStore((s) => s.reloadAll);
  const setReloadAll = useLeadsContainerStore((s) => s.setReloadAll);

  const filter = useMemo(() => {
    return tableFilter ? transformFilterToServer(tableFilter) : leadsFilter
  }, [tableFilter, leadsFilter]);

  const setFilter = useCallback((newFilter) => {
    return setTableFilter ? setTableFilter(transformServerToFilter(newFilter)) : setLeadsFilter(newFilter);
  }, [setLeadsFilter, setTableFilter]);

  const [fetching, setFetching] = useState(false);

  const active = useMemo(() => {
    return (
      filter?.values?.find((x) => x.field_name === "new_reply")?.value === "1"
    );
  }, [filter?.values]);

  const handleClick = useCallback(() => {
    if (active && filter) {
      if (
        filter?.values?.find((x) => x.field_name === "new_reply")?.value === "1"
      ) {
        setFilter({
          mode: filter.mode,
          values: filter.values.filter((x) => x.field_name !== "new_reply"),
        });
      }
    } else {
      let newFilter = { mode: "and", values: [] };
      if (filter?.values?.length > 0) {
        newFilter.values.push(filter);
      }
      newFilter.values.push({
        field_name: "new_reply",
        type: "equals",
        value: "1",
      });

      setFilter(newFilter);
    }

    if (!apiRef) {
      setReloadAll(true);
    }
  }, [active, filter, apiRef, setFilter, setReloadAll]);

  useEffect(() => {
    let requestFilter;
    let newFilter = { mode: "and", values: [] };
    if (filter?.values?.length > 0) {
      newFilter.values.push(filter);
    }
    if (!filter?.values?.find((x) => x.field_name === "new_reply")) {
      newFilter.values.push({
        field_name: "new_reply",
        type: "equals",
        value: "1",
      });
    }

    requestFilter = newFilter;

    const getFunction = userId ? getFirstPagePrmUser : getFirstPagePrm;

    setFetching(true);
    getFunction({
      id: userId,
      per_page: 25,
      filter: requestFilter,
    })
      .then((r) => {
        setNewsCount(r.data.number_of_results);
      })
      .finally(() => setFetching(false));
  }, [active, filter, userId, reloadAll]);

  return (
    <Button
      variant={active ? "filled" : "outline"}
      size="xs"
      radius={"xl"}
      ml={8}
      onClick={handleClick}
      leftSection={
        active ? <IconStarFilled size={16} /> : <IconStar size={16} />
      }
      disabled={reloadAll}
      rightSection={
        fetching ? (
          <Loader color={active ? "white" : "primary"} size={12} mx={6} />
        ) : (
          newsCount > 0 && <Badge size="sm">{newsCount}</Badge>
        )
      }
      miw={116}
    >
      new
    </Button>
  );
};

export default LeadsQuickNewFilter;
